import {
  ATTEMPT_TRIGGER_LABELS,
  getLabel,
} from '../constants/notification-delivery-labels.constant';
import type { DeliveryAttemptDTO } from '../schemas/get-notification-delivery.schema';

/** "Sistem", "Retry otomatis", or "Admin (<name>)" with "dihapus" for a deleted admin. */
export function getAttemptTriggerLabel(
  attempt: Pick<DeliveryAttemptDTO, 'trigger' | 'triggeredByAdmin'>
) {
  if (attempt.trigger === 'admin') {
    return `${ATTEMPT_TRIGGER_LABELS.admin} (${attempt.triggeredByAdmin?.name ?? 'dihapus'})`;
  }

  return getLabel(ATTEMPT_TRIGGER_LABELS, attempt.trigger);
}
